
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import * as React from 'react';

var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1742",
    fill: "none",
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2645",
    d: "M16 7.531a8.719 8.719 0 00-8.719 8.719A8.719 8.719 0 0016 24.969a8.719 8.719 0 008.719-8.719A8.719 8.719 0 0016 7.531zm0 1.688a7.027 7.027 0 017.031 7.031A7.027 7.027 0 0116 23.281a7.027 7.027 0 01-7.031-7.031A7.027 7.027 0 0116 9.219zm4.929 4.581l-.792-.8a.422.422 0 00-.6 0l-4.966 4.927-2.1-2.119a.422.422 0 00-.6 0l-.8.792a.422.422 0 000 .6l3.192 3.212a.422.422 0 00.6 0l6.064-6.012a.422.422 0 00.002-.6z",
    fill: "currentColor"
  })));
}

export { SvgSuccess as default };
//# sourceMappingURL=success.svg.js.map
